export const codingProfiles = [
  {
    platform: 'LeetCode',
    icon: '',
    username: '@SelvaprakashV',
    stats: {
      solved: '465+',
      rank: 'Top 10%',
      rating: '1750'
    },
    url: 'https://leetcode.com/u/SelvaprakashV/',
    color: '#FFA116'
  },
  {
    platform: 'GitHub',
    icon: '',
    username: '@Selvaprakash-V',
    stats: {
      repos: '30+',
      contributions: '250+',
      badges: '2 '
    },
    url: 'https://github.com/Selvaprakash-V',
    color: '#fff'
  },
  {
    platform: 'HackerRank',
    icon: '',
    username: '@selvaprakashv007',
    stats: {
      stars: '3 stars',
      badge: 'Java',
      certifications: 'SQL'
    },
    url: 'https://www.hackerrank.com/profile/selvaprakashv007',
    color: '#2EC866'
  },
  {
    platform: 'CodeChef',
    icon: '',
    username: '@selvaprakashv',
    stats: {
      solved: '216',
      Bronze: '2 ',
      streak: 'Daily '
    },
    url: 'https://www.codechef.com/users/selvaprakashv',
    color: '#5B4638'
  },
  {
    platform: 'Codeforces',
    icon: '',
    username: '@SelvaprakashV',
    stats: {
      rating: '1600',
      rank: 'Expert',
      contests: '50+'
    },
    url: 'https://codeforces.com/profile/SelvaprakashV',
    color: '#1F8ACB'
  },
  {
    platform: 'SkillRack',
    icon: '',
    username: '@SelvaprakashV',
    stats: {
      problems: '1250+',
      certificates: '16',
      Bronze: '413 '
    },
    url: 'https://www.skillrack.com/faces/resume.xhtml?id=514538&key=47cad40e11c02cf01a44755236a18b0a1e1920ac',
    color: '#FF6B00'
  }
];

export const getCodingProfiles = () => codingProfiles;
